import { useFormikContext } from 'formik';
import { MoneyCollectOutlined } from '@ant-design/icons';
import CardWithIcon from 'components/new-ui/base/card/CardWithIcon';
import { DutyPayer } from 'store/customers/customer';
import DutyAndVatForm from './DutyAndVatForm';
import DutyAndVatView from './DutyAndVatView';
import { FormFields, FormValues } from '../../types';

type Props = {
    isEditing: boolean;
};

const DutyAndVat = ({ isEditing }: Props) => {
    const formik = useFormikContext<FormValues>();

    const dutyPayerIsConsignee = formik.values?.[FormFields.DutyAndVat.DUTY_PAYER] === DutyPayer.CONSIGNEE;

    const content = isEditing ? <DutyAndVatForm /> : <DutyAndVatView showAEP5Section={dutyPayerIsConsignee} />;

    return (
        <CardWithIcon
            bordered={false}
            title="Duty & VAT"
            gap="large"
            iconProps={{
                icon: <MoneyCollectOutlined />,
                status: 'info',
            }}
            children={<div style={{ marginTop: 24 }}>{content}</div>}
        />
    );
};

export default DutyAndVat;
